import { baseURL, requestUrl } from "../../../Utils/baseUrls";
import { Input } from "../../../Components/AllInput/AllInput";
import { IconInVisible, IconVisible } from "../../../assests/icons/MapToolsIcons";
import { NewModal } from "../../../Components/New/Modal/NewModal";
import { setModalHeaderFooter } from "../../../ReduxTool/Slice/CommonReducers/CommonReducers";
import { useAppDispatch, useAppSelector } from "../../../ReduxTool/store/hooks";


import { useState } from "react";
import { validPassword } from "../../../Utils/Regex";
import { getPasswordErrMsg } from "../../../Utils/commonFunctions";
import { ModalId } from "../../../Components/New/Modal/ProfileModal/Const";
import { toast } from "react-toastify";
// import { changePasswordApi } from "../services/auth.service";

type PasswordForm = {oldPassword: string; newPassword: string; confirmPassword: string; };

export const useChangePassword = (userId: string, onSuccess: () => void) => {
  const [form, setForm] = useState<PasswordForm>({ oldPassword: "", newPassword: "", confirmPassword: "", });

  const [errors, setErrors] = useState<Record<string, string>>({});
  const [loading, setLoading] = useState(false);

  const validate = () => {
    const newErrors: Record<string, string> = {};

    if (!form.oldPassword) {
      newErrors.oldPassword = "This field is required";
    }

    if (!form.newPassword || form.oldPassword === form.newPassword || !validPassword.test(form.newPassword) || form.newPassword.length < 8
    ) { newErrors.newPassword = getPasswordErrMsg({ newPassword: form.newPassword, confirmPassword: form.confirmPassword, oldPassword: form.oldPassword, }); }

    if (!form.confirmPassword) {
      newErrors.confirmPassword = "This field is required";
    } else if (form.newPassword !== form.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const resetForm = () => { setForm({ oldPassword: "", newPassword: "", confirmPassword: "" })};

  const handleChange = (name: keyof PasswordForm, value: string) => {
    if (value?.length >20) return;
    setForm((prev) => ({  ...prev,  [name]: value, }));
    setErrors((prev) => ({ ...prev,  [name]: "",}));
  };

  const submit = async () => {
    if (!validate()) return;

    try {
      setLoading(true);

     let Response =  await changePasswordApi(userId, { oldpassword: form.oldPassword, newpassword: form.newPassword,  });
     
     if (Response.status === 200) {
      setForm({ oldPassword: "", newPassword: "", confirmPassword: "" });
      onSuccess();
      setErrors({});
      toast.success(`User password updated successfully`, { autoClose: 7000 });
     }
      
    } catch (err: any) {
      setErrors((prev) => ({ ...prev,oldPassword: err?.response?.data?.message || "Something went wrong",  }));
    } finally {
      setLoading(false);
    }
  };

  return { form, resetForm, errors, loading,handleChange, submit, };
};

const changePasswordApi = (userId: string, payload: any) => {
  return baseURL.put(`${requestUrl.changeUserPassword}/${userId}`, payload);
};

const ChangePassword = ({form,errors, onChange, passwordVisible,toggleVisibility, }: any) => {
  return (
    <div className="p-2 pb-6 space-y-4">
      {[{ name: "oldPassword", label: "Old Password" },{ name: "newPassword", label: "New Password" },{ name: "confirmPassword", label: "Confirm Password" },].map((field) => (
        <Input key={field.name} max={20} id={`security_pwd_${field.name}`} isRequired label={field.label}  name={field.name} value={form[field.name]} error={errors[field.name]}  type={passwordVisible[field.name] ? "text" : "password"}
         onChange={(e) => onChange(field.name, e.target.value)}  suficon={ passwordVisible[field.name] ? <IconVisible /> : <IconInVisible />   } handleSufIcon={() => toggleVisibility(field.name)}  />
      ))}
    </div>
  );
};

export default function SecurityPassword() {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.auth);
  const { modalid } = useAppSelector((state) => state.commonReducers.modal);

  const [passwordVisible, setPasswordVisible] = useState({ oldPassword: false, newPassword: false, confirmPassword: false, });

  const toggleVisibility = (field: string) => { setPasswordVisible((prev) => ({...prev, [field]: !prev[field as keyof object],})); };
  
  const closeModal = () => { 
      resetForm();
      dispatch(setModalHeaderFooter({title: "", btnTxt: "", secondaryBtnTxt: "", isheader: false,modalid: "" }));
    };
    
  const { form, errors, handleChange, submit,resetForm, loading} = useChangePassword(user.userid, closeModal);

  if (modalid !== "userSecurity") return null;

  return (<>
    {  <NewModal  isLoading={loading} modalSize="md" name="Security" btnName="Save" onClick={submit} setIsCLose={closeModal} isAbleCLick={!loading}  >
      <ChangePassword  form={form} errors={errors}  onChange={handleChange}  passwordVisible={passwordVisible}  toggleVisibility={toggleVisibility}   />
    </NewModal>}
    </>
  );
}


// import React, { memo, useState } from 'react'
// import { NewModal } from '../../../Components/New/Modal/NewModal'
// import { setModalHeaderFooter } from '../../../ReduxTool/Slice/CommonReducers/CommonReducers';
// import { useAppDispatch, useAppSelector } from '../../../ReduxTool/store/hooks';
// import { baseURL, requestUrl } from '../../../Utils/baseUrls';
// import { getPasswordErrMsg, testPassword } from '../../../Utils/commonFunctions';
// import ChangePassword from '../../../Components/ProfileModal/ChangePassword';
// import { validPassword } from '../../../Utils/Regex';

// function SecurityPassword() {
//     const dispatch = useAppDispatch();
//     const { user } = useAppSelector((state) => state.auth);
//     const { modalid, title, btnTxt, secondaryBtnTxt} = useAppSelector((state) => state.commonReducers.modal);

//     const [passwordHide, setPasswordHide] = useState({ oldpassword: false, newpassword: false, cpassword: false })
//     const [error, setError] = useState({});

//     const [changePasswordIn, setChangePasswordIn] = useState([
//         { name: "oldpassword", label: "Old password", value: "", error: "", type: "password" },
//         { name: "newpassword", label: "New password", value: "", error: "", type: "password" },
//         { name: "cpassword", label: "Confirm password", value: "", error: "", type: "password" }
//       ])

//     const validateForm = (name: string) => {
//         let isValid = true;
//         let isMobileValid = true;
//         let mobileErrorMsg = "Please enter a valid mobile number";
//         const errors: Record<string, string> = {};
//         const validations = {
//           "password": [
//             { field: "oldpassword", condition: !changePasswordIn[0].value, message: `${"This field is required"}` },
//             { field: "newpassword", condition: !changePasswordIn[1].value || changePasswordIn[0].value === changePasswordIn[1].value || !validPassword.test(changePasswordIn[1].value!) || changePasswordIn[1].value.length < 8, message: getPasswordErrMsg({ newPassword: changePasswordIn[1]?.value ?? "", confirmPassword: changePasswordIn[2]?.value ?? "", oldPassword: changePasswordIn[0]?.value ?? "" }) },
//             { field: "cpassword", condition: changePasswordIn[1].value !== changePasswordIn[2].value || !changePasswordIn[2].value, message: `${!changePasswordIn[2].value ? "This field is required" : "Confirm password must match new password"}` },
//           ]
//         };
    
//         for (const { field, condition, message } of validations[name as keyof object] as any) {
//           if (condition) {
//             errors[field] = message;
//             isValid = false;
//           }
//           else if (error) {
//             delete error[field as keyof object];
//             setError(error);
//           }
//         }
//         if (Object.keys(errors).length > 0) {
//           setError(errors);
//         };
//         return isValid;
//       };

//     const changePassword = async () => {
//         const isFormValid = validateForm("password");
//         if (isFormValid) {
//           const reqbody = {
//             oldpassword: changePasswordIn[0].value,
//             newpassword: changePasswordIn[2].value
//           };
//           try {
//             const { data } = await baseURL.put(`${requestUrl.changeUserPassword}/${user.userid}`, reqbody);
//             if (data && data.code === "200") {
//               // Toast({messageText:"Password update successfully.",messageType:"S",autoClose:1000,toastId:"UpdatedPasseord"});
//                // close passord modal after
//                handleClosePasswardModal()
//             //   setProfileModals({ ...profileModals, password: false, success: true, message: "Your password has been changed successfully." });
//               const resetPasswordValues = changePasswordIn.map(each => ({ ...each, value: "" }))
//               setChangePasswordIn(resetPasswordValues)
//               setError({});
//             };
//           } catch (err: any) {
//             console.log(err)
//             setError(prev => ({ ...prev, oldpassword: err.response.data.message }))
//           }
//         }
//       }

//     const handleChangePasswordClick = (title: string) => {

//     switch (title) {
//       case "Change Password":
//         changePassword()
//         break;
//       case "back":
//         const resetPasswordValues = changePasswordIn.map(each => ({ ...each, value: "" }))
//         setChangePasswordIn(resetPasswordValues)
//         // setProfileModals(prev => ({ ...prev, password: false }))
//         setError({})
//         break;
//       default:
//         break;
//     }
//   }

//    const handlePasswordChangeEl = (e: any, index: number) => {
//       const { name, value } = e.target
//       if (!testPassword(value) && value !== "") {
//         return false;
//       }
  
//       setChangePasswordIn((prev: any) => {
//         prev[index].value = value
//         return [...prev]
//       })
//       if (error) {
//         setError((prev: any) => ({ ...prev, oldpassword: !prev.oldpassword ? null : prev.oldpassword, [name]: null }));
//       }
//     }

//   const handleClosePasswardModal = () => { 
//     dispatch(setModalHeaderFooter({ title: "", btnTxt: "", secondaryBtnTxt: "", isheader: false,modalid:"" }))
//   }
    
//   return (
//     <>
//     {modalid === "changepassword" &&  (<NewModal maxheight="70vh" isAbleCLick onClick={handleChangePasswordClick} setIsCLose={() => handleClosePasswardModal()} name={"Profile Details"} children={<ChangePassword setPasswordHide={setPasswordHide} passwordHide={passwordHide}
//         changePasswordIn={changePasswordIn} handleChange={(e: any, i: number) => handlePasswordChangeEl(e, i)} error={error} />} modalSize="md" btnName="profile" />
//        )}
//        </>
//   )
// }

// export default memo(SecurityPassword)